module.exports = __webpack_public_path__ + "static/media/p_falanghinanew.f2410219.png";